import comp from "./CTAComponent";
export default comp;
